<template>
  <div class="dashboard">
    <el-alert
      :title="
        '欢迎 ' +
          userinfo['username'] +
          ' 登录系统 , 这是您第 ' +
          userinfo['login_count'] +
          ' 次登陆本系统 , 您上次登陆时间为: ' +
          last_login_time +
          ' , 上次登陆IP为:' +
          userinfo_last['lastLoginIp']
      "
      type="warning"
      show-icon
    >
    </el-alert>
    <el-row :gutter="40" class="panel-group">
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-people">
            <i class="el-icon-date" style="font-size:60px"></i>
          </div>
          <div class="card-panel-description">
            {{ inquiryCount[0] }}
            <div class="card-panel-text">昨日总询盘</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-message">
            <i class="el-icon-pie-chart" style="font-size:60px"></i>
          </div>
          <div class="card-panel-description">
            {{ inquiryCount[1] }}
            <div class="card-panel-text">今日总询盘</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-money">
            <i class="el-icon-coin" style="font-size:60px"></i>
          </div>
          <div class="card-panel-description">
            {{ inquiryCount[2] }}
            <div class="card-panel-text">未外理总询盘</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-shopping">
            <svg-icon icon-class="chart" style="font-size:60px" />
          </div>
          <div class="card-panel-description">
            {{ inquiryCount[3] }}
            <div class="card-panel-text">历史总询盘</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-card class="inquiryDataShow">
      <Echart class="echart" :chartData="echartData.inquiryData"> </Echart>
    </el-card>
    <div class="footer-grpah">
      <el-card class="left-echart-card">
        <Echart class="left-echart" :chartData="echartData.languageData" :isAxis="false"></Echart>
      </el-card>
      <el-card class="right-echart-card">
        <Echart class="right-echart" :chartData="echartData.domainsData" :isAxis="false"></Echart>
      </el-card>
    </div>
  </div>
</template>

<script>
import Echart from "../../components/Echart"
//import { getUserInfo, getInquiryCount, getChartData } from "@/api/home"
import { getInquiryCount, getChartData } from "@/api/home"
export default {
  components: {
    Echart
  },
  data() {
    return {
      userinfo_last: {},
      userinfo: {},
      inquiryCount: [],
      echartData: {
        inquiryData: {
          xData: [],
          series: []
        },
        languageData: {
          xData: [],
          series: [],
          title: {
            subtext: "询盘语种分布(限留言板)",
            left: "left"
          }
        },
        domainsData: {
          xData: [],
          series: [],
          title: {
            subtext: "域名分布(限留言板)",
            left: "left"
          }
        }
      }
    }
  },
  computed: {
    last_login_time: function() {
      return this.unix2timestamp(this.userinfo_last["lastLoginTime"])
    }
  },
  methods: {
    initData() {
      //获取userinfo
      this.userinfo_last = JSON.parse(localStorage.getItem("user_info_last"))
      this.userinfo = JSON.parse(localStorage.getItem("user_info"))
      //console.log(this.userinfo)
      //获取询盘总数
      // getInquiryCount().then(res => {
      //   this.inquiryCount = res.data
      // })
      //显示图表数据
      // getChartData().then(res => {
      //   this.showChartData(res.data)
      // })
      getInquiryCount()
        .then(res => {
          if (res.code === 50008 || res.code === 50014) {
            //if expired do not call the second api
            return
          } else {
            this.inquiryCount = res.data
            //显示图表数据
            getChartData().then(res => {
              this.showChartData(res.data)
            })
          }
        })
        .catch()
    },
    unix2timestamp(value) {
      if (!value) return null
      let date = new Date(parseInt(value) * 1000)
      let Y = date.getFullYear() + "-"
      let M = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) + "-" : date.getMonth() + 1 + "-"
      let D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " "
      let h = date.getHours() < 10 ? "0" + date.getHours() + ":" : date.getHours() + ":"
      let m = date.getMinutes() < 10 ? "0" + date.getMinutes() + ":" : date.getMinutes() + ":"
      let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    showChartData(data) {
      this.echartData.inquiryData.xData = data.days_7_date
      let sourceData = data.days_7_data

      this.echartData.inquiryData.series.push({
        name: "当天询盘量",
        data: sourceData,
        type: "line",
        smooth: 0.3
      })

      this.echartData.languageData.series.push({
        name: "语种分布",
        data: data.lang,
        type: "pie"
      })

      this.echartData.domainsData.series.push({
        name: "域名后缀分布",
        data: data.tlds,
        type: "pie"
      })
    }
  },
  created() {
    this.initData()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard {
  .panel-group {
    // border: 1px solid red;
    margin-top: 28px;
    // height: 400px;
    .card-panel-col {
      margin-bottom: 32px;
    }
    .card-panel {
      height: 108px;
      cursor: pointer;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      color: #666;
      background: #fff;
      box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
      border-color: rgba(0, 0, 0, 0.05);
      vertical-align: middle;
      &:hover {
        .card-panel-icon-wrapper {
          color: #fff;
        }
        .icon-people {
          background: #40c9c6;
        }
        .icon-message {
          background: #36a3f7;
        }
        .icon-money {
          background: #f4516c;
        }
        .icon-shopping {
          background: #9462e5;
        }
      }
      .icon-people {
        color: #40c9c6;
      }
      .icon-message {
        color: #36a3f7;
      }
      .icon-money {
        color: #f4516c;
      }
      .icon-shopping {
        color: #9462e5;
      }
      .card-panel-icon-wrapper {
        float: left;
        margin-top: 8px;
        margin-left: 20px;
        padding: 16px;
        transition: all 0.38s ease-out;
        border-radius: 6px;
      }
      .card-panel-icon {
        float: left;
        font-size: 48px;
      }
      .card-panel-description {
        float: right;
        font-weight: bold;
        margin: 26px;
        margin-left: 0px;
        font-size: 20px;
        .card-panel-text {
          line-height: 18px;
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
          margin-bottom: 12px;
          margin-top: 12px;
        }
        .card-panel-num {
          font-size: 20px;
        }
      }
    }
  }
  .inquiryDataShow {
    .echart {
      height: 320px !important;
    }
  }
  .footer-grpah {
    margin-top: 40px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    .left-echart-card {
      width: 48%;

      .left-echart {
        height: 260px !important;
      }
      // border:1px solid green;
    }
    .right-echart-card {
      width: 48%;

      .right-echart {
        height: 260px !important;
      }
      // border:1px solid red;
    }
  }
}
</style>
